import { CatButton } from '@blocks-react/components/Button';
import { FlyOutProps } from './types';
import cx from 'classnames';
import styles from './SelectDealerFlyout.module.scss';
import { FC } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconClose } from '@blocks-react/components/Icons/Close';
import { SELECT_DEALER_FLYOUT_MOBILE_IMG } from '../constants';

export const SelectDealerFlyout: FC<FlyOutProps> = (props) => {
  const {
    onClose,
    onSelectDealer,
    description,
    selectLabel,
    laterLabel,
    gaEventDetails
  } = props;
  const { selectStoreCTA, LaterCTA } = gaEventDetails ?? {};
  return (
    <div className={cx('p-3', styles['flyout-wrapper'])}>
      <div className="d-flex justify-content-between">
        <CatHeading variant="body-sm" className="pe-2">
          <span className="u-color--Black">{description}</span>
        </CatHeading>
        <CatIconClose className="mt-2" onClick={onClose} />
      </div>
      <figure className="my-3">
        <img
          className="w-100"
          src={SELECT_DEALER_FLYOUT_MOBILE_IMG.src}
          alt={SELECT_DEALER_FLYOUT_MOBILE_IMG.alt}
        />
      </figure>
      <div className="d-flex gap-3">
        <CatButton
          variant="primary"
          fullWidth
          onClick={onSelectDealer}
          data-track-event={selectStoreCTA?.gaprimaryCTA}
          data-track-attr-nltext={selectStoreCTA?.gaBtnEventName}
          data-track-attr-context={selectStoreCTA?.gaEventContext}
        >
          {selectLabel}
        </CatButton>
        <CatButton
          fullWidth
          onClick={onClose}
          data-track-event={LaterCTA?.gaprimaryCTA}
          data-track-attr-nltext={LaterCTA?.gaBtnEventName}
          data-track-attr-context={LaterCTA?.gaEventContext}
        >
          {laterLabel}
        </CatButton>
      </div>
    </div>
  );
};
